import { FileClient, RestClient } from "clients/rest/RestClient";
import { PageableResponse } from "clients/rest/PageableResponse";

// 送り状向けファイル出力APIクライアント

// 検索・エクセル出力リクエスト
export type B080090Request = Partial<{
  torikomisaki: string;
  tokuiCd: string;
  tokuishitenCd: string;
  shukashijiYmd: string;
  shijikaisu: string;
  batchNo: string;
  page: number;
  size: number;
}>;

// 検索レスポンス
export type B080090Response = {
  shukashijiYmd: string;
  shijikaisu: string;
  batchNm: string;
  shukayoteiYmd: string;
  nohinyoteiYmd: string;
  haisobin: string;
  hasokbnNm: string;
  juchudenpyoNo: string;
  tokuiNmView: string;
  nonyuNmView: string;
};

// 検索
export const B080090Find = (props: B080090Request) => {
  return RestClient.get<PageableResponse<B080090Response[]>>("b080090/find", {
    params: props,
  });
};

// エクセル出力
export const B080090GetExcel = (props: B080090Request) => {
  return FileClient.get("b080090/get/excel", {
    params: props,
  });
};
